// Sign in with Apple is native-only here; the Login screen only shows the
// Apple button on iOS. This stub keeps the import working on the web.
const notSupported = () =>
  Promise.reject(new Error('Sign in with Apple is not available on the web'));

const appleAuth = {
  isSupported: false,
  performRequest: notSupported,
  getCredentialStateForUser: notSupported,
  onCredentialRevoked: () => () => {},
  Operation: {LOGIN: 1, REFRESH: 2, LOGOUT: 3, IMPLICIT: 0},
  Scope: {EMAIL: 0, FULL_NAME: 1},
  State: {REVOKED: 0, AUTHORIZED: 1, NOT_FOUND: 2, TRANSFERRED: 3},
  Error: {
    UNKNOWN: '1000',
    CANCELED: '1001',
    INVALID_RESPONSE: '1002',
    NOT_HANDLED: '1003',
    FAILED: '1004',
  },
};

export const AppleButton = () => null;
export {appleAuth};
export default appleAuth;
